import { createAction, createReducer } from '@reduxjs/toolkit';
import { NewAppCookiesKey } from 'config/NewAppCookiesKey';
import Cookies from 'js-cookie';
import { switchLoadingDefault } from 'store/utils/genericReducers';
import { Loading } from 'types/ReduxStateTypes';
import { createAsyncAction } from 'utils/reduxUtils';

export const getWorkspaceId = createAsyncAction<undefined, string | null>(
  'workspace/getWorkspaceId'
);

export const setWorkspaceId = createAction<string>('workspace/SET_WORKSPACE_ID');

export interface WorkspaceState extends Loading {
  workspaceId: string | null;
  isReady: boolean;
}

export const workspaceSlice = createReducer<WorkspaceState>(
  () => {
    const lastSelectedWorkspaceId = Cookies.get(NewAppCookiesKey.lastSelectedWorkspaceId) || null;

    return {
      workspaceId: lastSelectedWorkspaceId,
      isLoading: false,
      isReady: false,
    };
  },
  builder =>
    builder
      .addCase(getWorkspaceId.request, switchLoadingDefault(true))
      .addCase(getWorkspaceId.success, (state, { payload }) => {
        Cookies.set(NewAppCookiesKey.lastSelectedWorkspaceId, payload || '');

        return {
          ...state,
          workspaceId: payload,
          isLoading: false,
          isReady: true,
        };
      })
      .addCase(getWorkspaceId.failure, switchLoadingDefault(false))
      .addCase(setWorkspaceId, (state, { payload }) => {
        Cookies.set(NewAppCookiesKey.lastSelectedWorkspaceId, payload || '');

        return {
          ...state,
          workspaceId: payload,
        };
      })
);
